import { PartnerType } from '@/app/utils/partners.enum'
import { httpClient } from '../http/httpClient'
import { StatusEnum } from '@/app/utils/status'

export interface SellerStatementParams {
  limit?: number
  userId?: string
  startDate?: string
  endDate?: string
}

export interface SellerStatementItem {
  contract?: string | number
  origin: string
  type: 'WITHDRAW' | PartnerType
  status?: StatusEnum
  statusAt?: string
  value: number
}

export interface SellerStatementGroup {
  date: string
  transactions: SellerStatementItem[]
}

export interface SellerStatementResponse {
  startDate: string
  endDate: string
  hasNext: boolean
  data: SellerStatementGroup[]
}

export async function sellerStatement(params?: SellerStatementParams) {
  const { data } = await httpClient.get<SellerStatementResponse>(
    '/user/statement',
    {
      params,
    },
  )

  return data
}
